<div *ngIf="showProgressBar" class="mat-app-background basic-container">
    <app-progress-bar-indeterminate-example></app-progress-bar-indeterminate-example>
  </div>
  <form #Form="ngForm" [formGroup]="formUpload" novalidate (ngSubmit)="import(formUpload.value, formUpload.valid)">
    <div class="card-body">
      <div class="row no-gutters">
        <div class="col-sm-12">
          <div class="form-check">
            <input
              type="checkbox"
              id="aSubmitId"
              formControlName="aSubmit"
              class="k-checkbox"
              (change)="handleChange()"
            />
            <label class="k-checkbox-label" for="aSubmitId">
              Check here to indicate that you want to import data. Note:Any existing Padbuilder data will be
              overwritten.
            </label>
          </div>
          <br />
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">
              PadBuilder File:
            </label>
            <div class="col-sm-10">
              <kendo-upload
                #padbuilderUploader
                [saveUrl]="uploadSaveUrl"
                [removeUrl]=""
                [restrictions]="pbRestrictions"
                [multiple]="false"
                (error)="errorUpload($event)"
                (success)="successUpload($event)"
                (upload)="fileUploading($event)"
                (uploadProgress)="uploadProgressHandler($event)"
                class="form-control"
                [disabled]="!isUploadEnabled"
              >
                <kendo-upload-messages headerStatusUploaded="File import in progress"> </kendo-upload-messages>
              </kendo-upload>
              <p style="color: #1984c8; font-size: .8em; margin-top: .5em;" [hidden]="!isExcelFile">
                Upload an excel file is required.
              </p>
            </div>
          </div>
          <div class="form-group row">
            
            <ng-template #notiftemplate></ng-template>
          </div>
        </div>
      </div>
    </div>
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="onCancelAction()">Cancel</button>
    
  </kendo-dialog-actions>  